import UserPools from './UserPools';

export default UserPools;